import gql from 'graphql-tag';

const accountDetails = gql`
  fragment accountDetails on Account {
    id
    name
    email_address
    phone_number
    username
  }
`;

export default accountDetails;
